import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoganapaticabs() {



const cardData = {
  keyword: "Pune to Ganpatipule Cabs",
  heading: "Lotus Cab: Pune to Ganpatipule Cabs",

  headingDescription:
    "Lotus Cab provides reliable and comfortable Pune to Ganpatipule cab service for families, pilgrims, corporate travelers, and weekend tourists. Ganpatipule, located along the scenic Konkan coast, is approximately 300+ km from Pune and is famous for its pristine beaches and the revered Swayambhu Ganpati Temple. Our sedan and SUV fleet ensures smooth long-distance highway travel with spacious seating and luggage support. Whether you need a one-way drop, round-trip taxi, or multi-day tour package, we offer flexible booking options with transparent per-kilometer pricing. All vehicles are air-conditioned, regularly serviced, and driven by experienced chauffeurs familiar with Konkan routes and ghat roads. With doorstep pickup anywhere in Pune and simple online booking support, Lotus Cab makes your Pune to Ganpatipule journey safe, comfortable, and hassle-free.",

  top: "Top Places to Visit in Ganpatipule with Lotus Cab",

  topPlaces: [
    {
      title: "Ganpatipule Temple",
      description:
        "Ganpatipule Temple is a sacred pilgrimage destination dedicated to Lord Ganesha and attracts devotees from across India. Travelers often book Pune to Ganpatipule cabs for comfortable temple darshan trips. The scenic coastal route enhances the spiritual journey. Lotus Cab provides safe and smooth long-distance travel with flexible return options."
    },
    {
      title: "Ganpatipule Beach",
      description:
        "Ganpatipule Beach is known for its clean shoreline and peaceful atmosphere. Families and couples book weekend taxi from Pune to enjoy a relaxing beach holiday. Comfortable AC travel ensures stress-free long-distance journeys."
    },
    {
      title: "Prachin Konkan Museum",
      description:
        "This open-air museum showcases traditional Konkan culture and lifestyle. Visitors prefer round-trip taxi booking for convenient sightseeing."
    },
    {
      title: "Jaigad Fort",
      description:
        "Jaigad Fort offers panoramic sea views and historical charm. SUV cab from Pune to Ganpatipule is ideal for exploring nearby attractions comfortably."
    },
    {
      title: "Jaigad Lighthouse",
      description:
        "The lighthouse provides stunning sunset views along the Arabian Sea coast. Travelers book flexible taxi packages to explore the surrounding areas."
    },
    {
      title: "Ratnagiri Beach",
      description:
        "Ratnagiri Beach is another scenic coastal attraction near Ganpatipule. Long-distance cab service ensures relaxed travel for family groups."
    },
    {
      title: "Thibaw Palace",
      description:
        "Thibaw Palace reflects historical Burmese architecture and attracts history enthusiasts. Comfortable sedan and SUV travel ensures convenient sightseeing."
    },
    {
      title: "Velneshwar Beach",
      description:
        "Velneshwar Beach is a serene getaway ideal for weekend trips. Lotus Cab provides safe ghat-road driving for coastal travel."
    }
  ],

  services: [
    {
      name: "Pune to Ganpatipule Cabs",
      description:
        "Book Pune to Ganpatipule cabs with Lotus Cab for safe and comfortable long-distance travel. Our fleet includes AC sedan and SUV options suitable for family trips, pilgrimage tours, and leisure travel. Experienced chauffeurs ensure smooth driving across highways and ghat sections. Transparent per-kilometer pricing with no hidden charges. Flexible one-way, round-trip, and multi-day booking options available."
    },
    {
      name: "Pune to Ganpatipule One Way Cab",
      description:
        "Affordable one-way taxi from Pune to Ganpatipule ideal for travelers planning extended coastal stays. Pay only for single-side distance with clear fare breakdown."
    },
    {
      name: "Pune to Ganpatipule Round Trip Taxi",
      description:
        "Convenient round-trip cab packages with flexible return timing. Suitable for weekend temple and beach visits."
    },
    {
      name: "Affordable Cab Pune to Ganpatipule",
      description:
        "Budget-friendly cab service with competitive per km rates and reliable vehicle options."
    },
    {
      name: "Luxury Cab Pune to Ganpatipule",
      description:
        "Premium SUV and luxury vehicle options for comfortable long-distance coastal travel."
    },
    {
      name: "SUV Cab Pune to Ganpatipule",
      description:
        "Spacious SUV taxis ideal for group travel with luggage support and comfortable seating."
    },
    {
      name: "Family Trip Cab Pune to Ganpatipule",
      description:
        "Safe and comfortable taxi service for family vacations and temple visits."
    },
    {
      name: "Online Booking Pune to Ganpatipule",
      description:
        "Easy online booking with instant confirmation and 24/7 customer assistance."
    }
  ],

  tableData: [
    ["Pune to Ganpatipule Cabs", "Pune to Ganpatipule One Way Cab"],
    ["Pune to Ganpatipule Round Trip Taxi", "Affordable Cab Pune to Ganpatipule"],
    ["Luxury Cab Pune to Ganpatipule", "SUV Cab Pune to Ganpatipule"],
    ["Sedan Taxi Pune to Ganpatipule", "Family Trip Cab Pune to Ganpatipule"],
    ["Corporate Cab Pune to Ganpatipule", "Weekend Trip Taxi Pune to Ganpatipule"],
    ["AC Cab Pune to Ganpatipule", "Online Booking Pune to Ganpatipule"],
    ["Best Outstation Cab Pune to Ganpatipule", "Pune to Ganpatipule Per Km Rate"],
    ["Same Day Return Cab Pune to Ganpatipule", "Group Tour Cab Pune to Ganpatipule"],
    ["Picnic Cab Pune to Ganpatipule", "Outstation Taxi Service Pune to Ganpatipule"],
    ["Chauffeur Driven Cab Pune to Ganpatipule", "Affordable Luxury Cab Pune to Ganpatipule"]
  ],

  whychoose: [
    { WhyChooseheading: "Experienced Highway Drivers", WhyChoosedescription: "Professional drivers familiar with Konkan routes and safe ghat driving ensure comfortable long-distance travel." },
    { WhyChooseheading: "Transparent Per Km Pricing", WhyChoosedescription: "Clear fare breakdown with no hidden charges for peace of mind." },
    { WhyChooseheading: "Comfortable AC Vehicles", WhyChoosedescription: "Well-maintained sedan and SUV fleet for relaxed coastal journeys." },
    { WhyChooseheading: "Flexible One-Way & Round Trip Options", WhyChoosedescription: "Choose travel package based on your itinerary needs." },
    { WhyChooseheading: "Ideal for Pilgrimage & Family Trips", WhyChoosedescription: "Spacious seating suitable for temple visits and vacations." },
    { WhyChooseheading: "Luxury & SUV Options Available", WhyChoosedescription: "Premium travel experience for long-distance comfort." },
    { WhyChooseheading: "Doorstep Pickup in Pune", WhyChoosedescription: "Convenient pickup from home, hotel, or airport." },
    { WhyChooseheading: "24/7 Customer Support", WhyChoosedescription: "Round-the-clock booking and travel assistance available." }
  ]
};

const faqData = [
  { question: "How far is Ganpatipule from Pune?", answer: "Ganpatipule is approximately 300–320 km from Pune and takes around 7–8 hours by road depending on traffic and route." },
  { question: "Is one-way taxi available?", answer: "Yes, one-way drop cab from Pune to Ganpatipule is available with transparent fare calculation." },
  { question: "Are SUV options available?", answer: "Yes, spacious SUV taxis are available for group and family travel." },
  { question: "Is round-trip booking possible?", answer: "Yes, flexible round-trip and multi-day packages are offered." },
  { question: "Is AC taxi provided?", answer: "Yes, fully air-conditioned vehicles are provided for comfort." },
  { question: "Are drivers experienced in ghat roads?", answer: "Yes, drivers are trained and experienced in Konkan and ghat route driving." },
  { question: "Is pricing per km transparent?", answer: "Yes, we follow clear per-kilometer fare structure with no hidden charges." },
  { question: "Is online booking available?", answer: "Yes, instant online booking with quick confirmation is available." },
  { question: "Is corporate booking allowed?", answer: "Yes, corporate travel packages are available." },
  { question: "Is 24/7 support available?", answer: "Yes, round-the-clock customer assistance is provided." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Patil",
    feedback:
      "Booked Pune to Ganpatipule cab for family temple visit. Smooth highway ride and very professional driver. Comfortable journey throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Neha Kulkarni",
    feedback:
      "Used SUV taxi for weekend coastal trip. Spacious seating and safe driving made our journey enjoyable. Highly recommended service.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Reliable and punctual service for group travel to Ganpatipule. Transparent pricing and comfortable vehicle.",
    rating: 5
  }
];















































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ganpatipule Cabs",
  "image": "https://lotuscab.com/assets/images/pune-to-ganpatipule-cabs.jpg", 
  "description": "Lotus Cab offers reliable taxi services from Pune to Ganpatipule for one-way, round-trip, weekend trips, family travel, corporate outings, and group tours. Choose from luxury, SUV, and AC cabs with chauffeur service, affordable per km rates, same-day return options, and easy online booking for safe and comfortable travel.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3600"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4299",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-to-ganpatipule-cabs"
  }
};








  return (
    <div>
      



<Helmet>
  <title>Contact: +91 8767592195 | Pune to Ganpatipule Cabs | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book taxi from Pune to Ganpatipule with Lotus Cab. One-way, round-trip, weekend, family & corporate trips. Luxury, SUV & AC cabs with chauffeur service. Affordable per km rates. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune to Ganpatipule Cabs, Pune to Ganpatipule One Way Cab, Pune to Ganpatipule Round Trip Taxi, Affordable Cab Pune to Ganpatipule, Luxury Cab Pune to Ganpatipule, SUV Cab Pune to Ganpatipule, Sedan Taxi Pune to Ganpatipule, Family Trip Cab Pune to Ganpatipule, Corporate Cab Pune to Ganpatipule, Weekend Trip Taxi Pune to Ganpatipule, AC Cab Pune to Ganpatipule, Online Booking Pune to Ganpatipule, Best Outstation Cab Pune to Ganpatipule, Pune to Ganpatipule Per Km Rate, Same Day Return Cab Pune to Ganpatipule, Group Tour Cab Pune to Ganpatipule, Picnic Cab Pune to Ganpatipule, Outstation Taxi Service Pune to Ganpatipule, Chauffeur Driven Cab Pune to Ganpatipule, Affordable Luxury Cab Pune to Ganpatipule" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/46.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoganapaticabs;